export default __webpack_public_path__ + "static/media/spaceshipWhite.2acc4f2d.jpeg";